import React, { useState, useEffect } from 'react';

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoginError('');
    setLoginSuccess(false);

    try {
      const response = await fetch('https://abmfy-be.vercel.app/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // You can store the accessToken (data.accessToken) in localStorage or context
        console.log('Login successful:', data);
        setLoginSuccess(true);
      } else {
        const errorText = await response.text();
        setLoginError(errorText || 'Login failed');
        console.error('Login failed:', errorText);
      }
    } catch (error) {
      setLoginError('An error occurred during login.');
      console.error('Error during login:', error);
    }
  };

  useEffect(() => {
    const isValid = email.trim() !== '' && password.trim() !== '';
    setIsFormValid(isValid);
  }, [email, password]);

  return (
    <div>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={!isFormValid}>Login</button>
      </form>
      {loginSuccess && <p style={{ color: 'green' }}>Login successful!</p>}
      {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
    </div>
  );
};

export default LoginForm;